/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Analyst-driven finding state transition (MDM-MATCH.26)
 * @export
 * @interface FindingStateTransitionRequest
 */
export interface FindingStateTransitionRequest {
    /**
     * Target finding state
     * @type {string}
     * @memberof FindingStateTransitionRequest
     */
    targetState: FindingStateTransitionRequestTargetStateEnum;
    /**
     * Mandatory justification
     * @type {string}
     * @memberof FindingStateTransitionRequest
     */
    reason: string;
    /**
     * Required for RISK_ACCEPTED; optional for other exception states
     * @type {Date}
     * @memberof FindingStateTransitionRequest
     */
    expiresAt?: Date;
    /**
     * Optional compliance framework scope
     * @type {Array<string>}
     * @memberof FindingStateTransitionRequest
     */
    complianceFrameworks?: Array<string>;
    /**
     * Tenant-only severity override (REQ-SEV-03)
     * @type {string}
     * @memberof FindingStateTransitionRequest
     */
    severityOverride?: FindingStateTransitionRequestSeverityOverrideEnum;
    /**
     * Required when severityOverride is set
     * @type {string}
     * @memberof FindingStateTransitionRequest
     */
    severityOverrideReason?: string;
}


/**
 * @export
 */
export const FindingStateTransitionRequestTargetStateEnum = {
    Open: 'OPEN',
    Remediated: 'REMEDIATED',
    FalsePositive: 'FALSE_POSITIVE',
    RiskAccepted: 'RISK_ACCEPTED',
    Exception: 'EXCEPTION',
    Superseded: 'SUPERSEDED',
    RemediationPending: 'REMEDIATION_PENDING'
} as const;
export type FindingStateTransitionRequestTargetStateEnum = typeof FindingStateTransitionRequestTargetStateEnum[keyof typeof FindingStateTransitionRequestTargetStateEnum];

/**
 * @export
 */
export const FindingStateTransitionRequestSeverityOverrideEnum = {
    Critical: 'CRITICAL',
    High: 'HIGH',
    Medium: 'MEDIUM',
    Low: 'LOW',
    Info: 'INFO'
} as const;
export type FindingStateTransitionRequestSeverityOverrideEnum = typeof FindingStateTransitionRequestSeverityOverrideEnum[keyof typeof FindingStateTransitionRequestSeverityOverrideEnum];


/**
 * Check if a given object implements the FindingStateTransitionRequest interface.
 */
export function instanceOfFindingStateTransitionRequest(value: object): value is FindingStateTransitionRequest {
    if (!('targetState' in value) || value['targetState'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function FindingStateTransitionRequestFromJSON(json: any): FindingStateTransitionRequest {
    return FindingStateTransitionRequestFromJSONTyped(json, false);
}

export function FindingStateTransitionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindingStateTransitionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'targetState': json['targetState'],
        'reason': json['reason'],
        'expiresAt': json['expiresAt'] == null ? undefined : (new Date(json['expiresAt'])),
        'complianceFrameworks': json['complianceFrameworks'] == null ? undefined : json['complianceFrameworks'],
        'severityOverride': json['severityOverride'] == null ? undefined : json['severityOverride'],
        'severityOverrideReason': json['severityOverrideReason'] == null ? undefined : json['severityOverrideReason'],
    };
}

export function FindingStateTransitionRequestToJSON(json: any): FindingStateTransitionRequest {
    return FindingStateTransitionRequestToJSONTyped(json, false);
}

export function FindingStateTransitionRequestToJSONTyped(value?: FindingStateTransitionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'targetState': value['targetState'],
        'reason': value['reason'],
        'expiresAt': value['expiresAt'] == null ? undefined : ((value['expiresAt']).toISOString()),
        'complianceFrameworks': value['complianceFrameworks'],
        'severityOverride': value['severityOverride'],
        'severityOverrideReason': value['severityOverrideReason'],
    };
}

